import React, { useEffect,  useState } from "react";

import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Offcanvas, Button } from "react-bootstrap";
import PayRollFilterBox from "../../../components/FilterBox/PayRollFilter/PayRollFilter";
import { FiMenu } from "react-icons/fi";
import PayRollTable from "../../../components/Tables/PayRollTable";
import {
  SalaryDeductSumm,
  DeptList,
  SalaryDeductSummFun,
} from "../../../Redux/Slice/PayRoll/PayRollSlice";
import { Loader } from "../../../components/Loader/Loader";
import { useTheme } from "../../../Themecontext/Themecontext";

export const ESI_PF_PT_Summary = () => {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { SalaryDeductSummdata } = useSelector((state) => state.PayRollSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWPAYROLL");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWPAYROLLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  let YearId = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(SalaryDeductSummFun());

    dispatch(
      DeptList({
        Firm: Firm,
        Year: YearId,
      }),
    );
    dispatch(
      SalaryDeductSumm({
        Firm: Firm,
        Year: YearId,
      }),
    );
  }, [dispatch, Firm, YearId]);
  // ✅ FILTER STATES
  const [filters, setFilters] = useState({
    year: [],
    month: [],
  });
  const [search, setSearch] = useState({
    year: "",
    month: "",
  });

  const [showFilter, setShowFilter] = useState(false);

  // ✅ ACTIVE BUTTON
  const [activeTab, setActiveTab] = useState("ESI STATEMENT");

  const toggleItem = (type, item) => {
    setFilters((prev) => {
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  // ✅ FILTER DATA

  const monthOptions = [
    { id: 4, month: "April" },
    { id: 5, month: "May" },
    { id: 6, month: "June" },
    { id: 7, month: "July" },
    { id: 8, month: "August" },
    { id: 9, month: "September" },
    { id: 10, month: "October" },
    { id: 11, month: "November" },
    { id: 12, month: "December" },
    { id: 1, month: "January" },
    { id: 2, month: "February" },
    { id: 3, month: "March" },
  ];
  const yearList =
    DataMain?.AC_Year_List?.map((item) => ({
      label: item?.AcYear,
      value: item?.AcYearID,
    })) || [];

  const monthList =
    monthOptions?.map((item) => ({
      label: item?.month,
      value: item?.id,
    })) || [];

  // ================== DATA ==================
  const getRowsPT = SalaryDeductSummdata?.PTSumm?.map((label, index) => ({
    // srNumber: index + 1,
    EmplName: label.EmplName,
    PTamt: label.PTamt,
  }));

  const getColumnsPT = [
    {
      key: "srNumber",
      label: "Sr. No.",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      key: "EmplName",
      label: "Employee",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { key: "PTamt", label: "PT Amount", format: "true", align: "right" },
  ];

  const getRowsESI = SalaryDeductSummdata?.ESISumm?.map((label, index) => ({
    // srNumber: index + 1,
    ESIamt: label.ESIamt,
    EmplName: label.EmplName,
    EsiNo: label.EsiNo,
  }));

  const getColumnsESI = [
    {
      key: "srNumber",
      label: "Sr. No.",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      key: "EmplName",
      label: "Employee",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { key: "EsiNo", label: "ESI Number", align: "right" },
    { key: "ESIamt", label: "ESI Amount", align: "right", format: "true" },
  ];

  const getRowsPF = SalaryDeductSummdata?.PFSumm?.map((label, index) => ({
    // srNumber: index + 1,
    PFNo: label.PFNo,
    EmplName: label.EmplName,
    PFamt: label.PFamt,
  }));

  const getColumnsPF = [
    {
      key: "srNumber",
      label: "Sr. No.",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      key: "EmplName",
      label: "Employee",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { key: "PFNo", label: "PF Number", align: "right" },
    { key: "PFamt", label: "PF Amount", align: "right", format: "true" },
  ];

  const applyFilters = () => {
    dispatch(SalaryDeductSummFun());
    let finalYearIDs = [];

    if (filters.year.length === 0) {
      finalYearIDs = [Cookies.get("FinancialYear")];
    } else {
      finalYearIDs = filters.year;
    }

    dispatch(
      SalaryDeductSumm({
        Firm: Firm,
        Year: finalYearIDs.join(","),
        MonthIDs: filters.month.join(","),
      }),
    );
  };

  // ================== TABLE SWITCH ==================
  const getTable = () => {
    if (activeTab === "ESI STATEMENT") {
      return (
        <PayRollTable columns={getColumnsESI} data={getRowsESI} showSearch />
      );
    }

    if (activeTab === "PF STATEMENT") {
      return (
        <PayRollTable columns={getColumnsPF} data={getRowsPF} showSearch />
      );
    }

    if (activeTab === "PT STATEMENT") {
      return (
        <PayRollTable columns={getColumnsPT} data={getRowsPT} showSearch />
      );
    }
  };
  if (SalaryDeductSummdata === null || SalaryDeductSummdata === "no") {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader />
      </div>
    );
  }
  return (
    <div
      style={{
        padding: "16px",
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      {/* MOBILE FILTER */}
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={() => setShowFilter(true)}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour12,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>

      {/* OFFCANVAS */}
      <Offcanvas
        show={showFilter}
        onHide={() => setShowFilter(false)}
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
        }}
      >
        <Offcanvas.Header
          closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
        >
          <Offcanvas.Title
            style={{
              color:
                isdark === "light"
                  ? iscolour?.Colour12
                  : iscolourDark?.Colour12,
            }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <PayRollFilterBox
              title="Year"
              items={yearList}
              search={search.year}
              setSearch={(val) => handleSearch("year", val)}
              selectedItems={filters.year}
              toggleItem={(item) => toggleItem("year", item)}
              selectAll={() => selectAll("year", yearList)}
            />

            <PayRollFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filters.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />

            <Button
              onClick={applyFilters}
              style={{
                // height: "44px",
                padding:"12px",
                borderRadius: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                border: "none",
                fontWeight: "700",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Row className="g-4">
        {/* FILTER */}
        <Col xl={3} lg={4} className="d-none d-lg-block">
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <PayRollFilterBox
              title="Year"
              items={yearList}
              search={search.year}
              setSearch={(val) => handleSearch("year", val)}
              selectedItems={filters.year}
              toggleItem={(item) => toggleItem("year", item)}
              selectAll={() => selectAll("year", yearList)}
            />

            <PayRollFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filters.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />

            <Button
              onClick={applyFilters}
              style={{
                // height: "44px",
                padding:"12px",
                borderRadius: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                border: "none",
                fontWeight: "700",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Col>

        {/* RIGHT SIDE */}
        <Col xl={9} lg={8}>
          {/* ✅ BUTTONS */}
          <Row className="g-3 mb-3">
            {["ESI STATEMENT", "PF STATEMENT", "PT STATEMENT"].map((btn) => (
              <Col xl={4} lg={4} md={4} sm={4} xs={4} key={btn}>
                <Button
                  onClick={() => setActiveTab(btn)}
                  className="hover-scale-btn"
                  style={{
                    width: "100%",
                    height: "58px",
                    backgroundColor:
                      activeTab === btn
                        ? isdark === "light"
                          ? iscolour?.Colour6
                          : iscolourDark?.Colour7
                        : isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour3,

                    border: `2px solid ${
                      activeTab === btn
                        ? isdark === "light"
                          ? iscolour?.Colour6
                          : iscolourDark?.Colour7
                        : isdark === "light"
                          ? iscolour?.Colour6
                          : iscolourDark?.Colour7
                    }`,

                    borderRadius: "14px",
                    fontWeight: "bold",

                    color:
                      activeTab === btn
                        ? isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour2
                        : isdark === "light"
                          ? iscolour?.Colour11
                          : iscolourDark?.Colour12,
                  }}
                >
                  {btn}
                </Button>
              </Col>
            ))}
          </Row>

          {/* TABLE */}
          <div
            style={{
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              {activeTab} SUMMARY
            </div>

            {getTable()}
          </div>
        </Col>
      </Row>
    </div>
  );
};
